var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9999 7.20001V5.60001C3.9999 3.39087 5.79076 1.60001 7.9999 1.60001C10.209 1.60001 11.9999 3.39087 11.9999 5.60001V7.20001C12.8836 7.20001 13.5999 7.91635 13.5999 8.80001V12.8C13.5999 13.6837 12.8836 14.4 11.9999 14.4H3.9999C3.11625 14.4 2.3999 13.6837 2.3999 12.8V8.80001C2.3999 7.91635 3.11625 7.20001 3.9999 7.20001ZM10.3999 5.60001V7.20001H5.5999V5.60001C5.5999 4.27452 6.67442 3.20001 7.9999 3.20001C9.32539 3.20001 10.3999 4.27452 10.3999 5.60001Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.4a8ce0f8ff6618b6e563c7e26ffca0a9.svg";
export { ForwardRef as ReactComponent };